'use strict';

/**
 * @module map
 * @author Sebastian Pekarek
 */

const $ = require('zepto');
const throttle = require('lodash.throttle');

const DataHelper = require('../helpers/data');
const EventHelper = require('../helpers/event');
const ConfigurationHelper = require('../helpers/configuration');

const CityMarker = require('./markers/city');
const PlaceMarker = require('./markers/place');
const FreefloaterMarker = require('./markers/freefloater');
const ListView = require('./list');
const MapBookeeAreaView = require('./mapBookeeArea');

class Map {
	constructor () {
		
		
		
		this.map = new google.maps.Map($('.map__google').get(0), {
			center: ConfigurationHelper.getGoogleMapsCenter(),
			zoom: ConfigurationHelper.getGoogleMapsZoom() + 4,
			disableDefaultUI: false,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			styles: ConfigurationHelper.getGoogleMapsStyle(),
			minZoom: 7,
			maxZoom: 19
		});
		
		
		if (ConfigurationHelper.getGoogleMapsBounds()) {
			const bounds = ConfigurationHelper.getGoogleMapsBounds();
			const boundsGmaps = new google.maps.LatLngBounds();
			boundsGmaps.extend(new google.maps.LatLng(bounds.neLat, bounds.neLng));
			boundsGmaps.extend(new google.maps.LatLng(bounds.swLat, bounds.swLng));
			
			this.map.fitBounds(boundsGmaps);
		}

		this.cities = {};
		this.places = {};
		this.freefloaters = {};
		
		this.list = new ListView(this);

		google.maps.event.addListener(this.map, 'bounds_changed', throttle(() => this.update(), 250));

		google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
			$('.app').removeClass('loading');
			google.maps.event.trigger(this.map, 'resize');

			setTimeout(() => {
				$('body').addClass('loaded');
				$('body').removeClass('loading');
			}, 500);
		});
		
		// CIRCLES
		// const c1 = new google.maps.Circle({
		// 	radius: 300, // 1m/s * 5min = 300m
		// 	center: ConfigurationHelper.getGoogleMapsCenter(),
		// 	map: this.map,
		// 	fillOpacity: 0,
		// 	strokeColor: '#FF0000',
		// 	strokeOpacity: 1,
		// 	strokeWeight: 1,
		// 	clickable: false,
		// 	zIndex: 1,
		// });
		// 
		// const c2 = new google.maps.Circle({
		// 	radius: 1000, // 1m/s * 15min = 900m
		// 	center: ConfigurationHelper.getGoogleMapsCenter(),
		// 	map: this.map,
		// 	fillOpacity: 0,
		// 	strokeColor: '#0000FF',
		// 	strokeOpacity: 1,
		// 	strokeWeight: 1,
		// 	clickable: false,
		// 	zIndex: 1,
		// });
		// google.maps.event.addListener(this.map, 'bounds_changed', () => {
		// 	c1.setCenter(this.map.getCenter());
		// 	c2.setCenter(this.map.getCenter());
		// });
		
		/**
		 *   Overlays
		 *   (Circles and BookeeAreas)
		 */
		this.mapBookeeAreaView = new MapBookeeAreaView(this.map);
		google.maps.event.addListener(this.map, 'zoom_changed', throttle(() => this.updateOverlays(), 200));
		this.updateOverlays();
		
		
		/**
		 *   Events
		*/
		EventHelper.onCitySelect((city) => {
			this.panTo(city, 12)
		});
		
		EventHelper.onGeochange( (data) => {
			if (data.geometry.viewport) {
				this.map.fitBounds(data.geometry.viewport);
			} else  if (data.geometry.location) {
				this.panTo(data.geometry.location, data.geometry.zoom || 14);
			}
		});
	}

	async update () {
		const bounds = this.map.getBounds();
		const zoom = this.map.getZoom();
		if(!bounds || !zoom) {
			return;
		}

		const markers = await DataHelper.request('getRequiredMarkersByBounds', {bounds, zoom});
		
		// update list
		this.list.update(markers, bounds);
		
		// add cities
		markers.cities.forEach(city => {
			if(!this.cities[city.id]) {
				this.cities[city.id] = new CityMarker(city, this);
			}
		});

		// remove cities
		Object.entries(this.cities).forEach(([id, marker]) => {
			if(markers.cities.findIndex(c => c.id === id) === -1) {
				marker.remove();
				delete this.cities[id];
			}
		});

		// add places
		markers.places.forEach(place => {
			if(!this.places[place.id]) {
				this.places[place.id] = new PlaceMarker(place, this);
			}
		});

		// remove places
		Object.entries(this.places).forEach(([id, marker]) => {
			if(markers.places.findIndex(c => c.id === id) === -1) {
				marker.remove();
				delete this.places[id];
			}
		});
		
		
		const freefloaters = await DataHelper.request('getFreefloaters', {bounds, zoom});
		// add freefloaters
		freefloaters.forEach(freefloater => {
			if(!this.freefloaters[freefloater.id]) {
				this.freefloaters[freefloater.id] = new FreefloaterMarker(freefloater, this);
			}
		});

		// remove freefloaters
		Object.entries(this.freefloaters).forEach(([id, marker]) => {
			if(freefloaters.findIndex(c => c.id === id) === -1) {
				marker.remove();
				delete this.freefloaters[id];
			}
		});
	}

	panTo (center, zoom) {
		this.map.panTo(center);
		if(zoom && zoom !== this.map.getZoom()) {
			setTimeout(() => {
				this.map.setZoom(zoom);
			}, 400);
		}
		// perhaps better to take the bounds if we have any???
		// if (this.object.bounds) {
		// 	const bounds =  new google.maps.LatLngBounds();
		// 	bounds.extend(new google.maps.LatLng(this.object.bounds.north, this.object.bounds.east));
		// 	bounds.extend(new google.maps.LatLng(this.object.bounds.south, this.object.bounds.west));
		// 	this.map.map.fitBounds(bounds);
		// } else {
		// 	this.map.panTo(this.object, 12);
		// }
	}
	
	updateOverlays () {
		const hideOverlays = this.map.getZoom() < 11;
		
		$('.map__layer').attr('data-center', hideOverlays ? '0' : '1');
		$('.map__layer--outer').attr('data-zoom', this.map.getZoom());
		$('.map__layer--inner').attr('data-zoom', this.map.getZoom());
		
		if (this.mapBookeeAreaView) {
			this.mapBookeeAreaView[hideOverlays ? 'hide' : 'show']();
		}
	}
}

module.exports = Map;
